import ApplicationModel from '../../ApplicationModel';
import { raw } from '@nx-js/observer-util';

function generateRawJson(value) {
  if (value instanceof ApplicationModel) {
    // Serialize all attributes
    const keys = Object.keys(value.attributes).filter(
      name => name !== '__typename' && value.isWriteable(name)
    );

    return keys.reduce((serialized, key) => {
      serialized[key] = generateRawJson(value[key]);
      return serialized;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(generateRawJson);
  } else {
    return value;
  }
}

export function JsonQuerySerialization(originalClass: any): any {
  return class extends originalClass {
    prepareForQuery() {
      return generateRawJson(raw(this));
    }
  };
}
